exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes loadingSpin-data-v-23d6f5bc{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.bf-btn[data-v-23d6f5bc]{font-size:14px;height:32px;padding:0 1em;border-radius:4px;border:1px solid #999;background:#fff;cursor:pointer;display:inline-flex;justify-content:center;align-items:center;vertical-align:middle}.bf-btn[data-v-23d6f5bc]:hover{border-color:#666}.bf-btn[data-v-23d6f5bc]:active{background-color:#eee}.bf-btn[data-v-23d6f5bc]:focus{outline:none}.bf-btn>.bficon[data-v-23d6f5bc]{order:1;margin-right:.2em}.bf-btn>.slot-wrapper[data-v-23d6f5bc]{order:2}.bf-btn.icon-right>.slot-wrapper[data-v-23d6f5bc]{order:1}.bf-btn.icon-right>.bficon[data-v-23d6f5bc]{order:2;margin-right:0;margin-left:.2em}.bf-btn>.loading[data-v-23d6f5bc]{animation:loadingSpin-data-v-23d6f5bc 1s infinite linear}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-23d6f5bc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/packages/button/btn2/btn2.vue
// module id = 28
// module chunks = 0